// extracted by mini-css-extract-plugin
export var divider = "Menu-module--divider--70377";
export var dropdown = "Menu-module--dropdown--60f53";
export var item = "Menu-module--item--a8bac";
export var label = "Menu-module--label--ec961";